import BaseLayer from "./BaseLayer";
import {drawLine} from "../utils/map_utils";
import {notNull} from "../../../utils/utils";

/**
 * Numeric per-seam residual label (px and microns) at each seam centre.
 * Pairs with the SeamDistortion colour layer (like "TXTY" + "TXTY Text").
 */
class SeamDistortionText extends BaseLayer {
    id = "seamDistortionText";
    label = "Seam Dist Text";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve) => {
        let {seamDistortion, slide, textColor, textSize} = this.props;
        if (!notNull(seamDistortion)) return resolve();

        let {tile_width, tile_height, uperpixel, y_fields} = slide;
        let tw = tile_width * uperpixel, th = tile_height * uperpixel;
        let txtColor = "#00d775";

        let plot = (mapObj, isTop) => {
            Object.entries(mapObj || {}).forEach(([key, val]) => {
                let x = parseInt(key.split('y')[0].split('x')[1]);
                let y = parseInt(key.split('y')[1]);
                if (isNaN(x) || isNaN(y)) return;
                let yV = y_fields - y - 1;
                let title = `${val.mag_px}px (${val.mag_um}um)`;
                if (isTop)
                    drawLine((x + 0.5) * tw, (yV + 1) * th, 1, this.layer.getSource(),
                        title, 1, txtColor, "", textColor, textSize);
                else
                    drawLine(x * tw, (yV + 0.5) * th, 1, this.layer.getSource(),
                        title, 0.25, txtColor, "", textColor, textSize);
            });
        };

        plot(seamDistortion.top, true);
        plot(seamDistortion.left, false);
        resolve();
    });
}

export default SeamDistortionText;
